import { render } from "./SynapseAnalyticsConfigurationForm.vue?vue&type=template&id=9603ba10&ts=true"
import script from "./SynapseAnalyticsConfigurationForm.vue?vue&type=script&lang=ts"
export * from "./SynapseAnalyticsConfigurationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__